let testimonials = [
  {
    text: `
   FR Professional. Efficient.  The team at ABNCA executed work needed to open my startup partnership expeditiously.  All I needed to do was whatsapp them my my documents.  Highly recommend their services.`,
    imageUrl:
      'https://cdn.pixabay.com/photo/2015/03/04/22/35/head-659652_960_720.png',
    name: 'Manjunath Kudlur',
    designation: 'Founding Partner',
    location: 'Davanagere',
  },
  {
    text: `
   FR Aditya BN & Co carried out an external audit for us to support our fund-raising process.  Their work was meticuluous.  It took more time than we expected but they helped us meet presentation target for meeting schedules.  The team was empathetic, professional and worked diligently to the end.`,
    imageUrl:
      'https://cdn.pixabay.com/photo/2015/03/04/22/35/head-659652_960_720.png',
    name: 'Sridharan Sainath',
    designation: 'CFO',
    location: 'Bengaluru',
  },
  {
    text: `
    FR I was recommended ABNCA for resolving tax-related hardships.  The team walked me through the complex process of writing to the Income-tax department to eliminate penalties that the department claimed I owed.  I am happy I could settle without entering litigation phase.`,
    imageUrl:
      'https://cdn.pixabay.com/photo/2015/03/04/22/35/head-659652_960_720.png',
    name: 'Raghu Bandopadhyay',
    designation: 'Tax & Compliance Officer',
    location: 'Kolkata',
  },
  {
    text: `
    FR Being a resident of Singapore I faced hardships in documentation and setting up business in India.  Aditya assisted me in setting up business and provided ongoing support over the past few years.  I am grateful for their commitment, organisation and efficiency and will continue their outstanding services in the future.`,
    imageUrl:
      'https://cdn.pixabay.com/photo/2015/03/04/22/35/head-659652_960_720.png',
    name: 'Mukesh Sharma',
    designation: 'Web Developer',
    location: 'Singapore',
  },
];

export default testimonials;
